export const validateFileExtensions = (file, acceptedFileExtensions) => {
  const fileExtension = file.name.split('.').pop();

  if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
    return false;
  }

  return true;
};
